import baseMethods from "../baseMethods";

let payment = {};
let base_url_wcy02 = baseMethods.wcy02_api_proxy;

// 初次注册初始化余额接口
payment.syncInfo = (payload) => {
    let myURL = base_url_wcy02 + '/sobeyMallPay/V1/balance/sync';
    const myHeader = {
        "Content-Type": "application/json;charset=UTF-8",
    };
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, payload, myHeader).then((res) => {
            console.log(res);
            if (res.rt_code === "SUCCESS") {
                resolve("SUCCESS");
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

// 初次注册初始化代金券接口
payment.syncVoucher = (payload) => {
    let myURL = base_url_wcy02 + '/sobeyMallPay/V1/voucher/sync';
    const myHeader = {
        "Content-Type": "application/json;charset=UTF-8",
    };
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, payload, myHeader).then((res) => {
            if (res.rt_code === "SUCCESS") {
                resolve("SUCCESS");
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//查询余额账户
payment.checkBalanceAccount = (payload) => {
    let myURL = base_url_wcy02 + '/sobeyMallPay/V1/balance/list';
    const myHeader = {
        "Content-Type": "application/json;charset=UTF-8",
    };
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, payload, myHeader).then((res) => {
            console.log('checkBalanceAccount_res', res);
            if (res) {
                resolve(res);
            } else {
                reject(false);
            }
        }).catch((err) => {
            console.log('checkBalanceAccount',err);
            reject(false);
        })
    })
};

//查询代金券账户
payment.checkVoucherAccount = (payload) => {
    let myURL = base_url_wcy02 + '/sobeyMallPay/V1/vouAccount/list';
    const myHeader = {
        "Content-Type": "application/json;charset=UTF-8",
    };
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, payload, myHeader).then((res) => {
            console.log('checkVoucherAccount_res', res);
            if (res) {
                resolve(res);
            } else {
                reject(false);
            }
        }).catch((err) => {
            console.log('checkVoucherAccount',err);
            reject(false);
        })
    })
};


export default payment;



// WEBPACK FOOTER //
// ./src/api/payment/payment.js